"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fsmConfig = exports.default = exports.Transition = exports.State = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _javascriptStateMachine = _interopRequireDefault(require("javascript-state-machine"));

var _env = require("../env");

var State = {
  PROFILE: 'profile',
  SSN_CREDIT: 'ssnCredit',
  TOKEN_CREDIT: 'tokenCredit',
  ERROR_CREDIT: 'errorCredit',
  INCORRECT_PIN: 'incorrectPin',
  NO_CREDIT: 'noCredit',
  NO_PROPERTY: 'noProperty',
  DATATREE_ERROR: 'datatreeError',
  UW_REVIEW: 'uwReview',
  ASSET_DEPLETION: 'assetDepletion',
  LIENS: 'liens',
  PRODUCT: 'product',
  MORE_PROFILE: 'moreProfile',
  HMDA: 'hmda',
  WAIT_SUMMARY: 'waitSummary',
  APP_SUMMARY: 'appSummary',
  DOC_VERIFY: 'docVerify',
  DOCUMENTS: 'documents',
  CONNECT_ASSET_ACCOUNTS: 'connectAssetAccounts',
  MANUAL_PAYSTUB_UPLOAD: 'manualPaystubUpload',
  INCOME_REVIEW: 'incomeReview',
  EMPL_VERIFY: 'emplVerify',
  WAIT_MERCHANT: 'waitMerchant',
  LIEN_ATTESTATION: 'lienAttestation',
  AUTOPAY: 'autopay',
  MANUAL_AUTOPAY: 'manualAutopay',
  ACH: 'ach',
  WAIT_SIGN: 'waitSign',
  SIGN: 'sign',
  CO_DEED: 'codeed',
  WAIT_NOTARY: 'waitNotary',
  NOTARY: 'notary',
  INSURANCE: 'insurance',
  // DOWNLOAD_DOCUMENTS: 'downloadDocuments',
  WAIT_FUND: 'waitFund',
  DECLINED: 'declined',
  DTI_DECLINED: 'dtiDeclined',
  DECLINED_PL_CROSS_SELL: 'declinedPlCrossSell',
  CREDIT_SCORE_DECLINED: 'creditScoreDeclined',
  DELINQUENCY: 'delinquency',
  COMPLETE: 'complete',
  WILDCARD: '*'
};
exports.State = State;
var Transition = {
  SOFT_CREDIT_NO_MATCH: 'softCreditNoMatch',
  CREDIT_LOCKED: 'creditLocked',
  CREDIT_FROZEN: 'creditFrozen',
  CREDIT_INCORRECT_PIN: 'creditIncorrectPin',
  SOFT_CREDIT_NO_CREDIT: 'softCreditNoCredit',
  PROPERTY_NO_MATCH: 'propertyNoMatch',
  DATATREE_NO_MATCH: 'datatreeNoMatch',
  UNDERWRITE_REVIEW: 'underwriteReview',
  ASSET_DEPLETION_DTI_DECLINE: 'assetDepletionDtiDecline',
  REPULL_SOFT_CREDIT: 'repullSoftCredit',
  LIEN_INFO: 'lienInfo',
  UNDERWRITE: 'underwrite',
  SELECT_PRODUCT: 'selectProduct',
  ADD_PROFILE_INFO: 'addProfileInfo',
  ADD_HMDA_INFO: 'addHmdaInfo',
  SUMMARY_SIGNING: 'summarySigning',
  SUMMARY_SIGNED: 'summarySigned',
  ID_RE_UPLOAD: 'idReUpload',
  ID_DOCS_UPLOADED: 'idDocsUploaded',
  AD_HOC_DOC_REQUIRED: 'adHocDocRequired',
  DOCUMENTS_UPLOADED: 'documentsUploaded',
  INCOME_PARTIAL_VERIFIED: 'incomePartialVerified',
  INCOME_VERIFIED: 'incomeVerified',
  EMPLOYER_VERIFICATION: 'employerVerification',
  EMPLOYER_VERIFIED: 'employerVerified',
  INCOME_VERIFIED_MERLOC: 'incomeVerifiedMerloc',
  MANUAL_DISBURSE_SETUP: 'manualDisburseSetup',
  MANUAL_DISBURSE_SETUP_MANUAL_PAY: 'manualDisburseManualPay',
  AUTOPAY_COMPLETED_MERLOC: 'autopayCompletedMerloc',
  MERCHANT_REVIEWED: 'merchantReviewed',
  LIEN_ATTESTATION: 'lienAttestation',
  ID_BYPASSED_VERIFICATION_REQUIRED: 'idBypassedVerificationRequired',
  DISBURSEMENT_ACH: 'disbursementAch',
  NOTE_SIGNING: 'noteSigning',
  CO_DEED_CONFIRMED: 'coDeedConfirmed',
  SIGNED: 'signed',
  DEED_SIGNING: 'deedSigning',
  // MANUAL_DEED: 'manualDeed',
  ENOTARY_SIGNED: 'enotarySigned',
  MANUAL_ENOTARY_SIGNED: 'manualEnotarySigned',
  INSURANCE_CONFIRMED: 'insuranceConfirmed',
  FINISH: 'finish',
  INACTIVE: 'inactive',
  DECLINE: 'decline',
  DTI_DECLINE: 'dtiDecline',
  DECLINE_PL_CROSS_SELL: 'declinePlCrossSell',
  CREDIT_SCORE_DECLINE: 'creditScoreDecline',
  DELINQUENCY_REVIEW: 'delinquencyReview',
  FUND: 'fund'
};
exports.Transition = Transition;
var fsmConfig = {
  init: State.PROFILE,
  transitions: [{
    name: Transition.SOFT_CREDIT_NO_MATCH,
    from: [State.PROFILE, State.LIENS, State.PRODUCT],
    to: State.SSN_CREDIT
  }, {
    name: Transition.CREDIT_LOCKED,
    from: State.WILDCARD,
    to: State.ERROR_CREDIT
  }, {
    name: Transition.CREDIT_FROZEN,
    from: State.WILDCARD,
    to: State.ERROR_CREDIT
  }, {
    name: Transition.CREDIT_INCORRECT_PIN,
    from: State.WILDCARD,
    to: State.INCORRECT_PIN
  }, {
    name: Transition.SOFT_CREDIT_NO_CREDIT,
    from: State.WILDCARD,
    to: State.NO_CREDIT
  }, {
    name: Transition.REPULL_SOFT_CREDIT,
    from: State.PROFILE,
    to: State.PRODUCT
  }, {
    name: Transition.PROPERTY_NO_MATCH,
    from: State.WILDCARD,
    to: State.NO_PROPERTY
  }, {
    name: Transition.DATATREE_NO_MATCH,
    from: State.WILDCARD,
    to: State.DATATREE_ERROR
  }, {
    name: Transition.LIEN_INFO,
    from: State.PROFILE,
    to: State.LIENS
  }, {
    name: Transition.UNDERWRITE,
    from: State.WILDCARD,
    to: State.PRODUCT
  }, {
    name: Transition.ASSET_DEPLETION_DTI_DECLINE,
    from: State.PRODUCT,
    to: State.ASSET_DEPLETION
  }, {
    name: Transition.SELECT_PRODUCT,
    from: State.PRODUCT,
    to: State.MORE_PROFILE
  }, {
    name: Transition.ADD_PROFILE_INFO,
    from: State.MORE_PROFILE,
    to: State.HMDA
  }, {
    name: Transition.ADD_HMDA_INFO,
    from: State.HMDA,
    to: State.WAIT_SUMMARY
  }, {
    name: Transition.SUMMARY_SIGNING,
    from: State.WILDCARD,
    to: State.APP_SUMMARY
  }, {
    name: Transition.SUMMARY_SIGNED,
    from: State.APP_SUMMARY,
    to: State.DOC_VERIFY
  }, {
    name: Transition.ID_RE_UPLOAD,
    from: State.WILDCARD,
    to: State.DOC_VERIFY
  }, {
    name: Transition.ID_DOCS_UPLOADED,
    from: State.DOC_VERIFY,
    to: State.INCOME_REVIEW
  }, {
    name: Transition.AD_HOC_DOC_REQUIRED,
    from: State.WILDCARD,
    to: State.DOCUMENTS
  }, {
    name: Transition.INCOME_PARTIAL_VERIFIED,
    from: State.WILDCARD,
    to: State.MANUAL_PAYSTUB_UPLOAD
  }, {
    name: Transition.INCOME_VERIFIED,
    from: State.INCOME_REVIEW,
    to: State.ACH
  }, {
    name: Transition.INCOME_VERIFIED_MERLOC,
    from: State.INCOME_REVIEW,
    to: State.MANUAL_AUTOPAY
  }, {
    name: Transition.MANUAL_DISBURSE_SETUP,
    from: State.WILDCARD,
    to: State.AUTOPAY
  }, {
    name: Transition.MANUAL_DISBURSE_SETUP_MANUAL_PAY,
    from: State.WILDCARD,
    to: State.WAIT_SIGN
  }, {
    name: Transition.AUTOPAY_COMPLETED_MERLOC,
    from: State.WILDCARD,
    to: State.WAIT_MERCHANT
  }, {
    name: Transition.MERCHANT_REVIEWED,
    from: State.WILDCARD,
    to: State.LIEN_ATTESTATION
  }, {
    name: Transition.LIEN_ATTESTATION,
    from: State.WILDCARD,
    to: State.WAIT_SIGN
  }, {
    name: Transition.DISBURSEMENT_ACH,
    from: [State.AUTOPAY, State.ACH],
    to: State.WAIT_SIGN
  }, {
    name: Transition.ID_BYPASSED_VERIFICATION_REQUIRED,
    from: State.WAIT_SIGN,
    to: State.DOC_VERIFY
  }, {
    name: Transition.EMPLOYER_VERIFICATION,
    from: State.WAIT_SIGN,
    to: State.EMPL_VERIFY
  }, {
    name: Transition.NOTE_SIGNING,
    from: State.WAIT_SIGN,
    to: State.SIGN
  }, {
    name: Transition.SIGNED,
    from: State.SIGN,
    to: State.CO_DEED
  }, {
    name: Transition.CO_DEED_CONFIRMED,
    from: State.CO_DEED,
    to: State.WAIT_NOTARY
  }, {
    name: Transition.DEED_SIGNING,
    from: State.WILDCARD,
    to: State.NOTARY
  }, // { name: Transition.MANUAL_DEED, from: State.WAIT_NOTARY, to: State.DOWNLOAD_DOCUMENTS },
  {
    name: Transition.ENOTARY_SIGNED,
    from: State.NOTARY,
    to: State.INSURANCE
  }, {
    name: Transition.MANUAL_ENOTARY_SIGNED,
    from: State.NOTARY,
    to: State.INSURANCE
  }, {
    name: Transition.INSURANCE_CONFIRMED,
    from: State.INSURANCE,
    to: State.WAIT_FUND
  }, {
    name: Transition.FINISH,
    from: State.WILDCARD,
    to: State.WAIT_FUND
  }, {
    name: Transition.INACTIVE,
    from: State.WILDCARD,
    to: State.DECLINED
  }, {
    name: Transition.DECLINE,
    from: State.WILDCARD,
    to: State.DECLINED
  }, {
    name: Transition.DTI_DECLINE,
    from: State.WILDCARD,
    to: State.DTI_DECLINED
  }, {
    name: Transition.DECLINE_PL_CROSS_SELL,
    from: State.WILDCARD,
    to: State.DECLINED_PL_CROSS_SELL
  }, {
    name: Transition.CREDIT_SCORE_DECLINE,
    from: State.WILDCARD,
    to: State.CREDIT_SCORE_DECLINED
  }, {
    name: Transition.DELINQUENCY_REVIEW,
    from: State.WILDCARD,
    to: State.DELINQUENCY
  }, {
    name: Transition.FUND,
    from: State.WILDCARD,
    to: State.COMPLETE
  }]
};
exports.fsmConfig = fsmConfig;

var HelocRouteFsm = /*#__PURE__*/function () {
  function HelocRouteFsm(profile, heloc) {
    (0, _classCallCheck2.default)(this, HelocRouteFsm);
    this.profile = profile;
    this.heloc = heloc;
    if (!profile || !heloc) throw Error('Profile and heloc are required');
    this.fsm = new _javascriptStateMachine.default(fsmConfig);
  }

  (0, _createClass2.default)(HelocRouteFsm, [{
    key: "run",
    value: function run() {
      var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var heloc = this.heloc,
          fsm = this.fsm,
          profile = this.profile;
      var status = heloc.status;
      var consents = heloc.consents || [];

      if (profile.name.uuid && profile.dob && heloc.income > 0 && heloc.selectedPropertyUuid && heloc.reason && consents.find(function (d) {
        return d.type === 'SOFT_CREDIT';
      }) !== undefined) {
        this._transition(Transition.LIEN_INFO);
      }

      if (status.softCreditNoMatch && !profile.hasSsn && !status.uwDecision) this._transition(Transition.SOFT_CREDIT_NO_MATCH);
      if (status.liensComplete || status.uwDecision) this._transition(Transition.UNDERWRITE); // uw decision on server is actually in ASSET_DEPLETION state but for backwards compatibility is never passed to client but
      // adding an extra conditional just in case it ever gets enabled

      var isCrossSellApp = heloc.crossSellApps && heloc.crossSellApps.length > 0;

      if ((!status.uwDecision || status.uwDecision === 'ASSET_DEPLETION') && status.uwSubDecision === 'UNVERIFIED_DTI_LIMITED' && !heloc.assetDepletion.complete && // // This is to prevent HELOC cross sell apps from hitting asset depletion after liens validation
      !isCrossSellApp) {
        this._transition(Transition.ASSET_DEPLETION_DTI_DECLINE);
      }

      if (heloc.term > 0 && heloc.amount > 0) this._transition(Transition.SELECT_PRODUCT); // TODO: uwDecision changes due to hard credit or user wants to select a different product

      var documents = heloc.documents || []; // TODO: set initial heloc state

      var property = (profile.addresses || []).find(function (a) {
        return a.uuid === heloc.selectedPropertyUuid;
      });

      if (fsm.state === State.MORE_PROFILE && (0, _typeof2.default)(property) === 'object' && property.ownership && profile.hasSsn && consents.find(function (d) {
        return d.type === 'HARD_CREDIT';
      }) !== undefined) {
        this._transition(Transition.ADD_PROFILE_INFO);
      }

      if (fsm.state === State.HMDA && heloc.hasHmda) {
        this._transition(Transition.ADD_HMDA_INFO);
      }

      if (heloc.hasHmda) {
        // we aren't routing Figure apps to these screens right now, so just transition thru
        if (status.disclosurelistSummaryReady) this._transition(Transition.SUMMARY_SIGNING);
        if (status.disclosurelistSummaryComplete) this._transition(Transition.SUMMARY_SIGNED);
      }

      var ided = documents.find(function (d) {
        return d.type === 'DRIVERSLICENSEFRONT';
      }) !== undefined || documents.find(function (d) {
        return d.type === 'IDCARDFRONT';
      }) !== undefined || documents.find(function (d) {
        return d.type === 'PASSPORTFRONT';
      }) !== undefined || documents.find(function (d) {
        return d.type === 'PERMANENTRESIDENTFRONT';
      }) !== undefined; // Email/Remind me later bypass for ID Verification

      if (status.idBypass || ided) this._transition(Transition.ID_DOCS_UPLOADED); // for now, assume we do not care about doc verify results

      if (status.uwSubDecision === 'VERIFIED_INCOME_MATCHED_OFFER' || status.uwSubDecision === 'FINAL_OFFER') {
        if (_env.isMerchant && !heloc.autopayAccount.uuid && heloc.payType === 'AUTOPAY') {
          this._transition(Transition.INCOME_VERIFIED_MERLOC);
        } else if (_env.isMerchant && (heloc.autopayAccount.uuid || heloc.payType === 'MANUAL')) {
          this._transition(Transition.AUTOPAY_COMPLETED_MERLOC);
        } else {
          this._transition(Transition.INCOME_VERIFIED);
        }
      } else {
        var incomeSources = heloc.incomeSources || [];
        var isSelfEmployed = incomeSources.some(function (source) {
          return source.employmentType === 'SELF_EMPLOYED';
        });
        if (heloc.status.manualPaystubUpload && !heloc.status.manualPaystubTasksComplete && !isSelfEmployed) this._transition(Transition.INCOME_PARTIAL_VERIFIED);
      }
      /** Merchant Heloc Specific State Transitions **/


      if (_env.isMerchant && heloc.term > 0 && heloc.amount > 0) {
        if (status.checklistStatus === 'LIEN_ATTESTATION') {
          this._transition(Transition.MERCHANT_REVIEWED);
        }

        if (heloc.lienAttestation) {
          this._transition(Transition.LIEN_ATTESTATION);
        }
      }

      var linkedDisburseAccount = Boolean(heloc.disburseAccount.uuid && heloc.disburseAccount.routingNumber);
      var hasAcceptableGiactStatus = status.giactAccountStatus === 'VERIFIED' || status.giactAccountStatus === 'PENDING_REVIEW';
      var selectedAutopayButNoAutopayAccount = heloc.payType === 'AUTOPAY' && !heloc.autopayAccount.uuid;

      if (linkedDisburseAccount && selectedAutopayButNoAutopayAccount && hasAcceptableGiactStatus) {
        this._transition(Transition.MANUAL_DISBURSE_SETUP);
      } // merchant heloc does not have a disburse account


      var payAccountComplete = (heloc.disburseAccount.uuid || _env.isMerchant) && heloc.payType === 'MANUAL' || (heloc.disburseAccount.uuid || _env.isMerchant) && heloc.autopayAccount.uuid;

      if (payAccountComplete && heloc.disburseAccount.routingNumber) {
        // if only plaid asset connected then confirmation required
        this._transition(Transition.DISBURSEMENT_ACH);
      }

      if (linkedDisburseAccount && hasAcceptableGiactStatus && heloc.payType === 'MANUAL') {
        this._transition(Transition.MANUAL_DISBURSE_SETUP_MANUAL_PAY);
      }

      if (payAccountComplete && status.employmentVerificationNeeded) this._transition(Transition.EMPLOYER_VERIFICATION); // Only transition back to DOC_VERIFY when idBypass is true and no ID found in docs

      if (linkedDisburseAccount && status.idBypass && !ided) this._transition(Transition.ID_BYPASSED_VERIFICATION_REQUIRED); // Applicant should reselect their offer

      if (heloc.term === 0 && heloc.rate === 0 && status.uwSubDecision === 'VERIFIED_OFFER') this._transition(Transition.UNDERWRITE); // TODO: handle ad hoc document upload if doc upload tasks exist
      // this._transition(Transition.AD_HOC_DOC_REQUIRED);

      if (payAccountComplete && status.disclosurelistClosingReady) this._transition(Transition.NOTE_SIGNING);
      if (status.disclosurelistClosingComplete) this._transition(Transition.SIGNED);
      if (heloc.coDeedStatus === 'COMPLETE') this._transition(Transition.CO_DEED_CONFIRMED);
      if (status.disclosurelistNotaryReady) this._transition(Transition.DEED_SIGNING);
      if (status.primaryParticipantAcceptComplete || status.disclosurelistNotaryComplete) this._transition(Transition.ENOTARY_SIGNED); // this assumes that user still completes the app up until enotary but is somehow unable to complete the process

      if (fsm.state === State.NOTARY && status.manualDeedSigningComplete) this._transition(Transition.MANUAL_ENOTARY_SIGNED);
      if (heloc.insurance.complete) this._transition(Transition.INSURANCE_CONFIRMED); // flow is done, waiting for back end processing

      if ((status.checklistStatus === 'GEN_RESCISSION' || status.checklistStatus === 'RESCISSION' || status.checklistStatus === 'RECORDING' || status.checklistStatus === 'FUNDABLE') && heloc.insurance.complete) {
        // NEVER SKIP INSURANCE
        this._transition(Transition.FINISH);
      } // passed in transition


      if (transition) this._transition(transition); // error states

      if (status.propertyComplete && status.datatreeNoMatch) this._transition(Transition.DATATREE_NO_MATCH);
      if (status.propertyNoMatch) this._transition(Transition.PROPERTY_NO_MATCH);
      if (status.creditFrozen && !heloc.hasFrozenPin) this._transition(Transition.CREDIT_FROZEN);
      if (status.creditLocked) this._transition(Transition.CREDIT_LOCKED);
      if (status.creditFrozenWithPin) this._transition(Transition.CREDIT_INCORRECT_PIN);
      if (status.softCreditNoMatchWithSsn) this._transition(Transition.SOFT_CREDIT_NO_CREDIT);
      if (status.showDelinquencyReview) this._transition(Transition.DELINQUENCY_REVIEW);
      if (!heloc.active) this._transition(Transition.INACTIVE);
      if (status.uwDecision === 'DECLINE' || status.hasAal) this._transition(Transition.DECLINE);
      if (status.uwDecision === 'DECLINE' && status.dtiDecline) this._transition(Transition.DTI_DECLINE);
      if (status.uwDecision === 'DECLINE' && status.plCrossSell) this._transition(Transition.DECLINE_PL_CROSS_SELL);
      if (status.creditScoreDecline) this._transition(Transition.CREDIT_SCORE_DECLINE);
      if (status.checklistStatus === 'CANCELLED' && isCrossSellApp) this._transition(Transition.DECLINE); // complete states

      if (heloc.checklistStatus === 'COMPLETE') this._transition(Transition.FUND);
      return fsm.state;
    }
  }, {
    key: "_transition",
    value: function _transition(transition) {
      try {
        this.fsm[transition]();
      } catch (error) {
        // invalid transitions die but get logged for easy debugging
        console.warn(error); // eslint-disable-line no-console
      }
    }
  }]);
  return HelocRouteFsm;
}();

var _default = HelocRouteFsm;
exports.default = _default;